import React from 'react'
import './PageNav.css'
import Logo from '../../assets/logo.png'
import { Link } from 'react-router-dom';

import {ImCross} from 'react-icons/im'

const PageNav = () => {
  return (
    <nav className='page-nav'>
        <Link to="/" className='logo'><img src={Logo} alt="" loading='lazy' /></Link>
        <Link to="/" className='nav-icon' ><ImCross/></Link>
    </nav>
  )
}

export default PageNav;